import editorialStyle from "../../../components/editorial/style.scss";
import style from "./style.scss";

import { Fragment } from "preact";
import Link, {
  Button,
  ButtonList,
  ButtonBar,
  affiliateMerchants,
} from "../../../components/link";
import AffiliateDisclosure from "../../../components/affiliate-disclosure";
import Center from "../../../components/center";
import Editorial from "../../../components/editorial";
import FixedTable from "../../../components/fixed-table";
import Head from "../../../components/head";
import Hero from "../../../components/hero";
import ImageSet from "../../../components/image-set";
import Image from "../../../components/image";
import Author from "../../../components/author";
import EcoFlowCouponCode from "../components/coupon-code";
import Accordion from "../../../components/accordion";
import NoWrap from "../../../components/no-wrap";
import SlugLink from "../../../components/slug-link";
import SlugHeading from "../../../components/slug-heading";
import Tags from "../../../components/tags";
import PhotoListItem from "../../../components/photo-list-item";
import ReviewItem from "../../../components/review-item";
import Warning from "../../../components/warning";
import Questions from "../../../components/questions";
import namedRoutes from "../../../settings/routes";
import { lookupByUrl } from "../../../settings/route-data-lookup";
import YouTube from "../../../components/youtube";

import AffiliateAd from "../../../components/affiliate-ad";

const headerInfo = lookupByUrl(namedRoutes.ecoflow.altCharger.gen2);

const data = {
  isReleased: false,
  1000: {
    price: null,
    link: null,
  },
  600: {
    price: null,
    link: null,
  },
  xt150: {
    price: null,
    link: null,
  },
  xt60: {
    price: null,
    link: null,
  },
  plus1000Solar: {
    price: null,
    link: null,
  },
  videos: {
    showcase: null,
    install: null,
  },
};

const Page = () => (
  <div>
    <Head data={headerInfo} />
    <Hero
      positionY={34}
      background="/images/backgrounds/ecoflow-gen-2-alternator-chargers.webp?v=2"
      titlePrefix="EcoFlow"
      title="Alternator Chargers"
      subTitle="600W & Plus 1000W Models"
    />
    <Editorial>
      <Center>
        <Author
          published={headerInfo.datePublished}
          updated={headerInfo.dateModified}
        />
        <p>
          EcoFlow has announced two upcoming next-generation alternator
          chargers: <strong>EcoFlow Alternator Charger Plus 1000</strong> and{" "}
          <strong>EcoFlow Alternator Charger 600</strong>. Both models feature
          meaningful upgrades, including higher overall output and a reliable
          ignition-wire auto start that resolves compatibility issues with
          modern smart alternators. The Plus 1000 further enhances flexibility
          by incorporating a dedicated solar input. These advancements position
          the new chargers as excellent, dependable options for vanlife, RV, and
          overland use.{" "}
        </p>

        <AffiliateDisclosure />

        {data.isReleased ? null : (
          <Fragment>
            <h2>Current Availability</h2>
            <p>
              Internationally, the new models have launched in select regions:
            </p>
            <ul>
              <li>
                <strong>Australia:</strong>{" "}
                <Link
                  affiliateData={affiliateMerchants.ecoflow}
                  href="https://au.ecoflow.com/products/ecoflow-alternator-charger-plus-1000"
                >
                  1000W
                </Link>
              </li>
              <li>
                <strong>Europe:</strong>{" "}
                <Link
                  affiliateData={affiliateMerchants.ecoflow}
                  href="https://eu.ecoflow.com/products/600w-alternator-charger?variant=50705288986967"
                >
                  600W
                </Link>{" "}
                and{" "}
                <Link
                  affiliateData={affiliateMerchants.ecoflow}
                  href="https://eu.ecoflow.com/products/1000w-alternator-charger?variant=48080282714455"
                >
                  1000W
                </Link>
              </li>
              <li>
                <strong>France:</strong>{" "}
                <Link
                  affiliateData={affiliateMerchants.ecoflow}
                  href="https://fr.ecoflow.com/products/600w-alternator-charger?variant=50611851395419"
                >
                  600W
                </Link>{" "}
                and{" "}
                <Link
                  affiliateData={affiliateMerchants.ecoflow}
                  href="https://fr.ecoflow.com/products/chargeur-d-alternateur-ecoflow-1000-w-1?variant=51212363530587"
                >
                  1000W
                </Link>
              </li>
              <li>
                <strong>Italy:</strong>{" "}
                <Link
                  affiliateData={affiliateMerchants.ecoflow}
                  href="https://it.ecoflow.com/products/600w-alternator-charger?variant=55236143055224"
                >
                  600W
                </Link>{" "}
                and{" "}
                <Link
                  affiliateData={affiliateMerchants.ecoflow}
                  href="https://it.ecoflow.com/products/1000w-alternator-charger?variant=50977668006237"
                >
                  1000W
                </Link>
              </li>
              <li>
                <strong>Japan:</strong>{" "}
                <Link
                  affiliateData={affiliateMerchants.ecoflow}
                  href="https://jp.ecoflow.com/products/ecoflow-alternator-charger-600?variant=52234748395887"
                >
                  600W
                </Link>{" "}
                and{" "}
                <Link
                  affiliateData={affiliateMerchants.ecoflow}
                  href="https://jp.ecoflow.com/products/ecoflow-alternator-charger-plus-1000?variant=52234754785647"
                >
                  1000W
                </Link>
              </li>
              <li>
                <strong>Spain:</strong>{" "}
                <Link
                  affiliateData={affiliateMerchants.ecoflow}
                  href="https://es.ecoflow.com/products/600w-alternator-charger"
                >
                  600W
                </Link>{" "}
                and{" "}
                <Link
                  affiliateData={affiliateMerchants.ecoflow}
                  href="https://es.ecoflow.com/products/1000w-alternator-charger?variant=48146695094619"
                >
                  1000W
                </Link>
              </li>
              <li>
                <strong>United Kingdom:</strong>{" "}
                <Link
                  affiliateData={affiliateMerchants.ecoflow}
                  href="https://uk.ecoflow.com/products/600w-alternator-charger?variant=51029173207379"
                >
                  600W
                </Link>{" "}
                and{" "}
                <Link
                  affiliateData={affiliateMerchants.ecoflow}
                  href="https://uk.ecoflow.com/products/1000w-alternator-charger?variant=48154485850451"
                >
                  1000W
                </Link>
              </li>
            </ul>
            <p>
              EcoFlow has not announced a <strong>North American</strong> launch
              timeline, and based on recent communication it appears the release
              will not occur in 2026. The official English manuals are linked
              below for both models for reference.
            </p>

            <p>
              <strong>Need a solution now?</strong> <br />
              If you are currently building out your power system,{" "}
              <Link href={namedRoutes.ecoflow.altCharger.review}>
                EcoFlow’s existing alternator chargers
              </Link>{" "}
              are great options to consider. <strong>I personally use</strong>{" "}
              EcoFlow's 800W alternator charger in{" "}
              <Link href={namedRoutes.inventory.vanlife}>my camper van</Link>{" "}
              and have found it to be a game-changer for keeping my power
              station topped off while on the road.
            </p>
            <p style="font-size:0.9em;opacity:0.7;">
              This page will be updated as new information becomes available.
            </p>
          </Fragment>
        )}

        <ImageSet
          showAlt
          size={2}
          border={true}
          images={[
            {
              lg: "/images/products/ecoflow/alternator-charger-plus-1000/1000w-includes.webp",
              alt: "EcoFlow Alternator Charger Plus 1000 & XT150 output cable",
            },
            {
              lg: "/images/products/ecoflow/alternator-charger-600/600w-includes.webp",
              alt: "EcoFlow Alternator Charger 600 & XT60 output cable",
            },
          ]}
        />

        <Accordion
          items={[
            {
              heading: "Table of Contents",
              content: (
                <ol>
                  <li>
                    <SlugLink>Overview</SlugLink>
                    <ol class="upper-alpha">
                      <li>
                        <SlugLink>What's New</SlugLink>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <SlugLink>Product Photos</SlugLink>
                  </li>
                  <li>
                    <SlugLink>Specifications</SlugLink>
                    <ol class="upper-alpha">
                      <li>
                        <SlugLink>Full Specifications</SlugLink>
                      </li>
                      <li>
                        <SlugLink>Check Compatibility</SlugLink>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <SlugLink>Cables and Accessories</SlugLink>
                    <ol class="upper-alpha">
                      <li>
                        <SlugLink>Output Cables</SlugLink>
                      </li>
                      <li>
                        <SlugLink>Accessories</SlugLink>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <SlugLink>Ignition Wire</SlugLink>
                    <ol class="upper-alpha">
                      <li>
                        <SlugLink>Use a Fuse Tap</SlugLink>
                      </li>
                      <li>
                        <SlugLink>Toggle Switch</SlugLink>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <SlugLink>Interesting Configurations</SlugLink>
                  </li>
                  <li>
                    <SlugLink>Mobile App</SlugLink>
                  </li>
                  <li>
                    <SlugLink>Videos</SlugLink>
                  </li>
                  <li>
                    <SlugLink>Questions & Feedback for EcoFlow</SlugLink>
                    <ol class="upper-alpha">
                      <li>
                        <SlugLink>Questions</SlugLink>
                      </li>
                      <li>
                        <SlugLink>Feedback</SlugLink>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <SlugLink>Summary</SlugLink>
                  </li>
                </ol>
              ),
            },
          ]}
        />
      </Center>
      <Center>
        <SlugHeading tag="h2">Overview</SlugHeading>
        <p>
          The new chargers feature a sleeker, modern design that aligns visually
          with EcoFlow's new Delta 3 series power stations.
        </p>
        <ul>
          <li>
            <strong>3-in-1 multifunctional design:</strong> In addition to
            charging, both models offer reverse charging and battery maintenance
            modes for the vehicle's battery when used with the XT150 output
            cable.
          </li>
          <li>
            <strong>Fast charging:</strong> The 1000W model can charge at up to
            1000W directly from the vehicle using the included XT150 cable or up
            to 720W using an optional XT60 cable. The 600W model can charge at
            up to 600W.
          </li>
          <li>
            <strong>Dust Protection:</strong> Engineered for dusty off-road use,
            featuring IP4X-rated dust protection to guard against airborne
            particles. Its sealed, fanless design relies on natural convection
            for cooling, minimizing dust ingress and reducing the risk of
            electrical shorts.
          </li>
          <li>
            <strong>Compatible with many cars and devices:</strong> Also works
            to charge other brands of power stations (Bluetti, Jackery, etc.)
            when using the XT60 output cable.
          </li>
          <li>
            <strong>XT150 Adapter:</strong> The following power stations will
            still require an adapter when using the XT150 cable: Delta Pro 3,
            Delta Pro, Delta 3 Ultra Plus, Delta 3 Max Plus. Alternatively, they
            can instead use the 4+8 Output Cable which offers the same
            functionality.
          </li>
        </ul>

        <ImageSet
          showAlt
          size={2}
          shadow={true}
          images={[
            {
              lg: "/images/products/ecoflow/alternator-charger-plus-1000/1000w-system.webp",
              alt: "EcoFlow Alternator Charger Plus 1000 connected system",
            },
            {
              lg: "/images/products/ecoflow/alternator-charger-600/600w-system.webp",
              alt: "EcoFlow Alternator Charger 600 connected system",
            },
          ]}
        />

        <SlugHeading tag="h2">What's New</SlugHeading>
        <ul>
          <li>
            <strong>Auto Start via Ignition Wire:</strong> Can be configured to
            automatically power on when the vehicle's ignition is engaged via a
            built-in ignition wire (on the input cable) to the vehicle's ACC/IGN
            fuse box. This is a major improvement; especially for vehicles with
            smart alternators or when using the XT60 output cable.
          </li>
          <li>
            <strong>New Solar Input:</strong> The 1000W model also features a
            solar input port (11-60V⎓15A, 300W max). Solar and alternator inputs
            can be used together, reducing alternator load. When solar input is
            available, the combined total output is still capped at 1000W.
          </li>
          <li>
            <strong>Dual Alternator Chargers:</strong> You can connect two
            Alternator Chargers to different XT150 ports on an EcoFlow Delta Pro
            3 (and Delta Pro 3 only) for increased charging capacity. With this
            setup, the two products can achieve a total maximum power output of
            1700W.
          </li>
          <li>
            <strong>New Cables:</strong> The cables feature improved tool-free
            connectors and appear to be incompatible with Gen 1 chargers.
          </li>
          <li>
            <strong>Optimized Enclosure:</strong> Combines visual appeal with
            functional rear cooling fins that actively support thermal
            management during high-load operation.
          </li>
          <li>
            <strong>Audio Cues:</strong> Provides audio cues when powering
            on/off, switching modes, etc. It is unclear if this can be disabled
            in the app (likely).
          </li>
        </ul>
      </Center>
      <Center>
        <SlugHeading tag="h2">Product Photos</SlugHeading>
        <ImageSet
          maxShow={5}
          size={5}
          shadow={true}
          images={[
            {
              lg: "/images/products/ecoflow/alternator-charger-600/600w-pluging-in.webp",
            },
            {
              lg: "/images/products/ecoflow/alternator-charger-plus-1000/alternator-charger-plus-1000_2-cables.webp",
              alt: "EcoFlow Alternator Charger Plus 1000 with two cables connected",
            },
            {
              lg: "/images/products/ecoflow/alternator-charger-plus-1000/alternator-charger-plus-1000_zoom.webp",
              alt: "EcoFlow Alternator Charger Plus 1000 with two cables connected",
            },
            {
              lg: "/images/products/ecoflow/alternator-charger-plus-1000/alternator-charger-plus-1000_solar-cable.webp",
              alt: "EcoFlow Alternator Charger Plus 1000 with solar cable connected",
            },
            {
              lg: "/images/products/ecoflow/alternator-charger-plus-1000/carplay.webp",
            },
            {
              lg: "/images/products/ecoflow/alternator-charger-plus-1000/duel-chargers.webp",
            },
            {
              lg: "/images/products/ecoflow/alternator-charger-plus-1000/cable-end.webp",
            },
          ]}
        />

        <h3>Alternator Charger Plus 1000</h3>
        <ImageSet
          size={3}
          border={true}
          showAlt
          images={[
            {
              lg: "/images/products/ecoflow/alternator-charger-plus-1000/1000w-front.webp?v=2",
              alt: "EcoFlow Alternator Charger Plus 1000 ports",
            },
            {
              lg: "/images/products/ecoflow/alternator-charger-plus-1000/1000w-right.webp?v=2",
              alt: "EcoFlow Alternator Charger Plus 1000",
            },
            {
              lg: "/images/products/ecoflow/alternator-charger-plus-1000/1000w-top.webp",
              alt: "EcoFlow Alternator Charger Plus 1000 bottom",
            },
          ]}
        />

        <h3>Alternator Charger 600</h3>
        <ImageSet
          size={3}
          border={true}
          showAlt
          images={[
            {
              lg: "/images/products/ecoflow/alternator-charger-600/600w-front.webp?v=2",
              alt: "EcoFlow Alternator Charger 600 ports",
            },
            {
              lg: "/images/products/ecoflow/alternator-charger-600/600w-right.webp?v=2",
              alt: "EcoFlow Alternator Charger 600",
            },
            {
              lg: "/images/products/ecoflow/alternator-charger-600/600w-top.webp",
              alt: "EcoFlow Alternator Charger 600 bottom",
            },
          ]}
        />

        <AffiliateAd brand="EcoFlow" size="billboard" />
      </Center>
      <Center>
        <SlugHeading tag="h2">Specifications</SlugHeading>
        <p>
          Detailed comparison of Gen 2 vs Gen 1 EcoFlow alternator chargers:
        </p>
        <FixedTable>
          <table>
            <thead>
              <tr>
                <th class={editorialStyle.sticky}>Model</th>
                <th>Plus 1000</th>
                <th>600</th>
                <th>800W</th>
                <th>500W</th>
              </tr>
            </thead>
            <tbody>
              <tr class={editorialStyle.noHover}>
                <th class={editorialStyle.sticky}>
                  <strong>Photo</strong>
                </th>
                <td>
                  <Image
                    src="/images/products/ecoflow/alternator-charger-plus-1000/front.webp"
                    alt="EcoFlow Alternator Charger Plus 1000"
                    showAlt
                    maxHeight={100}
                  />
                </td>
                <td>
                  <Image
                    src="/images/products/ecoflow/alternator-charger-600/front.webp"
                    alt="EcoFlow Alternator Charger 600"
                    showAlt
                    maxHeight={100}
                  />
                </td>
                <td>
                  <Image
                    src="/images/products/ecoflow/alternator-charger-800w/front-right.webp"
                    alt="EcoFlow Alternator Charger 800W"
                    showAlt
                    maxHeight={100}
                  />
                </td>
                <td>
                  <Image
                    src="/images/products/ecoflow/alternator-charger-500w/front.webp"
                    alt="EcoFlow Alternator Charger 500W"
                    showAlt
                    maxHeight={100}
                  />
                </td>
              </tr>
              <tr class={editorialStyle.noHover}>
                <th class={editorialStyle.sticky}>
                  <strong>Links</strong>
                </th>
                <td>
                  <ButtonBar>
                    {data[1000].link ? (
                      <Button
                        size="small"
                        affiliateData={affiliateMerchants.ecoflow}
                        href={data[1000].link}
                        icon="EcoFlow"
                      >
                        Store
                      </Button>
                    ) : (
                      <Button
                        size="small"
                        affiliateData={affiliateMerchants.ecoflow}
                        href="https://au.ecoflow.com/products/ecoflow-alternator-charger-plus-1000"
                        icon="EcoFlow"
                      >
                        Australia
                      </Button>
                    )}
                    <Button
                      size="small"
                      external
                      href="https://manuals.ecoflow.com/us/product/alternator-charger-plus-1000"
                      secondary
                    >
                      Manual
                    </Button>
                  </ButtonBar>
                </td>
                <td>
                  <ButtonBar>
                    {data[600].link ? (
                      <Button
                        size="small"
                        affiliateData={affiliateMerchants.ecoflow}
                        href={data[600].link}
                        icon="EcoFlow"
                      >
                        Store
                      </Button>
                    ) : (
                      <Button
                        size="small"
                        affiliateData={affiliateMerchants.ecoflow}
                        href="https://jp.ecoflow.com/products/ecoflow-alternator-charger-600"
                        icon="EcoFlow"
                      >
                        Japan
                      </Button>
                    )}
                    <Button
                      size="small"
                      external
                      href="https://manuals.ecoflow.com/us/product/alternator-charger-600"
                      secondary
                    >
                      Manual
                    </Button>
                  </ButtonBar>
                </td>
                <td>
                  <ButtonBar>
                    <Button
                      size="small"
                      affiliateData={affiliateMerchants.ecoflow}
                      href="https://us.ecoflow.com/products/800w-alternator-charger?variant=41064248836169"
                      icon="EcoFlow"
                    >
                      Store
                    </Button>
                    <Button
                      size="small"
                      external
                      href="https://manuals.ecoflow.com/us/product/alternator-charger-800w"
                      secondary
                    >
                      Manual
                    </Button>
                  </ButtonBar>
                </td>
                <td>
                  <ButtonBar>
                    <Button
                      size="small"
                      affiliateData={affiliateMerchants.ecoflow}
                      href="https://us.ecoflow.com/products/ecoflow-500w-alternator-charger?variant=54348224954441"
                      icon="EcoFlow"
                    >
                      Store
                    </Button>
                    <Button
                      size="small"
                      external
                      href="https://manuals.ecoflow.com/eu/product/alternator-charger-500w"
                      secondary
                    >
                      Manual
                    </Button>
                  </ButtonBar>
                </td>
              </tr>
              <tr>
                <th class={editorialStyle.sticky}>
                  <strong>Price</strong>
                </th>
                <td>{data[1000].price ? `$${data[1000].price}` : "TBD"}</td>
                <td>{data[600].price ? `$${data[600].price}` : "TBD"}</td>
                <td>
                  <NoWrap>
                    $269 <s>$599</s>
                  </NoWrap>
                </td>
                <td>
                  <NoWrap>
                    $199 <s>$389</s>
                  </NoWrap>
                </td>
              </tr>
              <tr class={editorialStyle.rowBorder}>
                <th class={editorialStyle.sticky}>
                  <strong>Cable Included</strong> <sup>1</sup>
                </th>
                <td>
                  <mark class={style.xt150}>
                    <strong>XT150</strong>
                  </mark>{" "}
                  <sup>2</sup>
                </td>
                <td>
                  <mark class={style.xt60}>
                    <strong>XT60</strong>
                  </mark>{" "}
                  <sup>2</sup>
                </td>
                <td>
                  <mark class={style.xt150}>
                    <strong>XT150</strong>
                  </mark>{" "}
                  <sup>2</sup>
                </td>
                <td>
                  <mark class={style.xt60}>
                    <strong>XT60</strong>
                  </mark>{" "}
                  <sup>2</sup>
                </td>
              </tr>
              <tr class={editorialStyle.rowBorder}>
                <th class={editorialStyle.sticky}>
                  <strong>Max Charge Rate</strong> <sup>3</sup>
                  <br />
                  <mark class={style.xt60}>XT60 cable</mark>
                </th>
                <td>
                  720W <sup>4</sup>
                </td>
                <td>
                  <mark class={style.xt60}>
                    <strong>600W</strong>
                  </mark>
                </td>
                <td>500W</td>
                <td>
                  <mark class={style.xt60}>
                    <strong>500W</strong>
                  </mark>
                </td>
              </tr>
              <tr>
                <th class={editorialStyle.sticky}>
                  <strong>Max Charge Rate</strong>
                  <br />
                  <mark class={style.xt150}>XT150 cable</mark>
                </th>
                <td>
                  <mark class={style.xt150}>
                    <strong>1000W</strong>
                  </mark>{" "}
                  <sup>4</sup>
                </td>
                <td>600W</td>
                <td>
                  <mark class={style.xt150}>
                    <strong>800W</strong>
                  </mark>
                </td>
                <td>500W</td>
              </tr>
              <tr>
                <th class={editorialStyle.sticky}>
                  <strong>Max Reverse Charge</strong> <sup>3</sup>
                  <br />
                  <mark class={style.xt150}>XT150 cable</mark>
                </th>
                <td>
                  <mark class={style.xt150}>
                    <strong>1000W</strong>
                  </mark>
                </td>
                <td>600W</td>
                <td>
                  <mark class={style.xt150}>
                    <strong>800W</strong>
                  </mark>
                </td>
                <td>500W</td>
              </tr>
              <tr>
                <th class={editorialStyle.sticky}>
                  <strong>Battery Maintenance</strong> <sup>3</sup>
                  <br />
                  <mark class={style.xt150}>XT150 cable</mark>
                </th>
                <td>
                  <mark class={style.xt150}>
                    <strong>100W</strong>
                  </mark>
                </td>
                <td>100W</td>
                <td>
                  <mark class={style.xt150}>
                    <strong>100W</strong>
                  </mark>
                </td>
                <td>100W</td>
              </tr>
              <tr>
                <th class={editorialStyle.sticky}>
                  <strong>Solar Input</strong>
                </th>
                <td>
                  11-60V⎓15A
                  <br />
                  300W max
                </td>
                <td>--</td>
                <td>--</td>
                <td>--</td>
              </tr>
              <tr class={editorialStyle.rowBorder}>
                <th class={editorialStyle.sticky}>
                  <strong>Size</strong>
                </th>
                <td>
                  10.9 × 7.4 × 1.5"
                  <br />
                  (276 × 187 × 38 mm)
                </td>
                <td>
                  8.8 × 6.0 × 1.5"
                  <br />
                  (224 × 153 × 38 mm)
                </td>
                <td>
                  9.5 × 7.6 × 1.4"
                  <br />
                  (242 × 194 × 35 mm)
                </td>
                <td>
                  9.5 × 7.6 × 1.4"
                  <br />
                  (242 × 194 × 35 mm)
                </td>
              </tr>
              <tr>
                <th class={editorialStyle.sticky}>
                  <strong>Weight</strong>
                </th>
                <td>
                  3.7 lbs
                  <br />
                  (1.7 kg)
                </td>
                <td>
                  2.4 lbs
                  <br />
                  (1.1 kg)
                </td>
                <td>
                  5.1 lbs
                  <br />
                  (2.3 kg)
                </td>
                <td>
                  3.5 lbs
                  <br />
                  (1.6 kg)
                </td>
              </tr>
              <tr>
                <th class={editorialStyle.sticky}>
                  <strong>Operating Temperature</strong> <sup>5</sup>
                </th>
                <td>
                  14° to 113°F
                  <br />
                  (-10° to 45°C)
                </td>
                <td>
                  14° to 113°F
                  <br />
                  (-10° to 45°C)
                </td>
                <td>
                  -4° to 140°F
                  <br />
                  (-20° to 60°C)
                </td>
                <td>
                  -4° to 140°F
                  <br />
                  (-20° to 60°C)
                </td>
              </tr>
            </tbody>
          </table>
        </FixedTable>
        <p class="caption">
          <strong>1.</strong> Custom Fit Output Cable offers same functionality
          and charge rates as XT150 output cable. <strong>2.</strong> Bolded
          values are defaults with included cable. <strong>3.</strong> Reverse
          Charge and Battery Maintenance modes aren't supported while using the
          XT60 output cable and the max charge rate could be lower depending on
          the power station. <strong>4.</strong> Combined output maximum is the
          same as alternator output maximum (1000W from alternator or 700W
          alternator and 300W solar). <strong>5.</strong> While the operating
          temperature range is smaller it is inline with the discharge and
          storage temperatures for EcoFlow's power stations.
        </p>

        <SlugHeading tag="h3">Full Specifications</SlugHeading>
        <Accordion
          headingsAs="h4"
          items={[
            {
              heading: "Alternator Charger Plus 1000",
              content: (
                <Fragment>
                  <h5>General</h5>
                  <ul style="font-size:0.9em;">
                    <li>
                      <strong>Model:</strong> EF-AC-001
                    </li>
                    <li>
                      <strong>Net Weight:</strong> 3.7 lbs (1.7 kg)
                    </li>
                    <li>
                      <strong>Dimensions:</strong> 10.9 × 7.4 × 1.5 in (276 ×
                      187 × 38 mm)
                    </li>
                    <li>
                      <strong>Included Output Cable:</strong> XT150
                    </li>
                    <li>
                      <strong>Input Cable AWG:</strong> 6AWG
                    </li>
                    <li>
                      <strong>Ingress Protection:</strong> IPX4
                    </li>
                    <li>
                      <strong>Warranty period:</strong> 2 years
                    </li>
                    <li>
                      <strong>EMC level:</strong> Class B
                    </li>
                  </ul>
                  <hr />
                  <h5>Power</h5>
                  <ul class="none" style="font-size:0.9em;">
                    <li>
                      <strong>Charge Mode:</strong>
                      <ul>
                        <li>ALT IN Port Input: 12/24V⎓(11-31V⎓), 75A Max</li>
                        <li>
                          BATTERY Port Output: 24V⎓/40-60V⎓, 20A Max, 1000W Max
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Reverse Charge Mode:</strong>
                      <ul>
                        <li>BATTERY Port Input: 40-60V⎓, 20A Max</li>
                        <li>ALT IN Port Output: 13.8/27.6V⎓, 75A Max</li>
                      </ul>
                    </li>
                    <li>
                      <strong>Battery Maintenance Mode:</strong>
                      <ul>
                        <li>BATTERY Port Input: 40-60V⎓, 3A Max</li>
                        <li>ALT IN Port Output: 13.8/27.6V⎓, 100W Max</li>
                      </ul>
                    </li>
                    <li>
                      <strong>Solar Port Input:</strong> 48V⎓(11-60V⎓), 15A Max,
                      300W Max
                    </li>
                    <li>
                      <strong>Rated Current of Fuse:</strong> 125A
                    </li>
                    <li>
                      <strong>Protection Type:</strong> Reverse polarity
                      protection/Overcurrent protection/Short circuit
                      protection/Overvoltage and undervoltage protection
                      (Provided with integral protection against overloads)
                    </li>
                  </ul>
                  <hr />
                  <h5>Environmental Temperature</h5>
                  <ul style="font-size:0.9em;">
                    <li>
                      <strong>Operating Temperature:</strong> 14° to 113°F (-10°
                      to 45°C)
                    </li>
                    <li>
                      <strong>Storage Temperature:</strong> -22° to 158°F (-30°
                      to 70°C)
                    </li>
                    <li>
                      <strong>Operating Humidity :</strong> ≤95%
                    </li>
                    <li>
                      <strong>Storage Humidity :</strong> ≤95%
                    </li>
                  </ul>
                  <hr />
                  <h5>Communications</h5>
                  <ul style="font-size:0.9em;">
                    <li>
                      <strong>Wi-Fi:</strong> Supported
                    </li>
                    <li>
                      <strong>Bluetooth:</strong> Supported
                    </li>
                  </ul>
                </Fragment>
              ),
            },
            {
              heading: "Alternator Charger 600",
              content: (
                <Fragment>
                  <h5>General</h5>
                  <ul style="font-size:0.9em;">
                    <li>
                      <strong>Model:</strong> EF-AC-002
                    </li>
                    <li>
                      <strong>Net Weight:</strong> 2.4 lbs (1.1 kg)
                    </li>
                    <li>
                      <strong>Dimensions:</strong> 8.8 × 6.0 × 1.5 in (224 × 153
                      × 38 mm)
                    </li>
                    <li>
                      <strong>Included Output Cable:</strong> XT60
                    </li>
                    <li>
                      <strong>Input Cable AWG:</strong> 8AWG
                    </li>
                    <li>
                      <strong>Ingress Protection:</strong> IPX4
                    </li>
                    <li>
                      <strong>Warranty period:</strong> 2 years
                    </li>
                    <li>
                      <strong>EMC level:</strong> Class B
                    </li>
                  </ul>
                  <hr />
                  <h5>Power</h5>
                  <ul class="none" style="font-size:0.9em;">
                    <li>
                      <strong>Charge Mode:</strong>
                      <ul>
                        <li>ALT IN Port Input: 12/24V⎓(11-31V⎓), 45A Max</li>
                        <li>
                          BATTERY Port Output: 24V⎓/40-60V⎓, 12A Max, 600W Max
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Reverse Charge Mode:</strong>
                      <ul>
                        <li>BATTERY Port Input: 40-60V⎓, 12A Max</li>
                        <li>ALT IN Port Output: 13.8/27.6V⎓, 45A Max</li>
                      </ul>
                    </li>
                    <li>
                      <strong>Battery Maintenance Mode:</strong>
                      <ul>
                        <li>BATTERY Port Input: 40-60V⎓, 3A Max</li>
                        <li>ALT IN Port Output: 13.8/27.6V⎓, 100W Max</li>
                      </ul>
                    </li>
                    <li>
                      <strong>Rated Current of Fuse:</strong> 125A
                    </li>
                    <li>
                      <strong>Protection Type:</strong> Reverse polarity
                      protection/Overcurrent protection/Short circuit
                      protection/Overvoltage and undervoltage protection
                      (Provided with integral protection against overloads)
                    </li>
                  </ul>
                  <hr />
                  <h5>Environmental Temperature</h5>
                  <ul style="font-size:0.9em;">
                    <li>
                      <strong>Operating Temperature:</strong> 14° to 113°F (-10°
                      to 45°C)
                    </li>
                    <li>
                      <strong>Storage Temperature:</strong> -22° to 158°F (-30°
                      to 70°C)
                    </li>
                    <li>
                      <strong>Operating Humidity :</strong> ≤95%
                    </li>
                    <li>
                      <strong>Storage Humidity :</strong> ≤95%
                    </li>
                  </ul>
                  <hr />
                  <h5>Communications</h5>
                  <ul style="font-size:0.9em;">
                    <li>
                      <strong>Wi-Fi:</strong> Supported
                    </li>
                    <li>
                      <strong>Bluetooth:</strong> Supported
                    </li>
                  </ul>
                </Fragment>
              ),
            },
            {
              heading: "XT150 Output Cable",
              content: (
                <Fragment>
                  <ul style="font-size:0.9em;">
                    <li>
                      <strong>Length:</strong> 3.28ft (1m)
                    </li>
                    <li>
                      <strong>Cable AWG:</strong> 12AWG
                    </li>
                    <li>
                      <strong>Supported Modes:</strong>
                      <ul>
                        <li>Charge</li>
                        <li>Reverse Charge</li>
                        <li>Battery Maintenance</li>
                      </ul>
                    </li>
                  </ul>
                  <hr />
                  <p class="caption" style="font-size:0.9em;">
                    The following power stations require the{" "}
                    <Link
                      affiliateData={affiliateMerchants.ecoflow}
                      href="https://us.ecoflow.com/products/delta-pro-to-smart-generator-adapter?variant=39704596152393"
                    >
                      Smart Generator Adapter
                    </Link>{" "}
                    when using this cable: <NoWrap>Delta Pro</NoWrap>,{" "}
                    <NoWrap>Delta Pro 3</NoWrap>,{" "}
                    <NoWrap>Delta 3 Max Plus</NoWrap>,{" "}
                    <NoWrap>Delta 3 Ultra Plus</NoWrap>. An alternative option
                    is to purchase the 4+8 output cable or XT60 output cable.
                  </p>
                </Fragment>
              ),
            },
            {
              heading: "XT60 Output Cable",
              content: (
                <Fragment>
                  <ul style="font-size:0.9em;">
                    <li>
                      <strong>Length:</strong> 3.28ft (1m)
                    </li>
                    <li>
                      <strong>Cable AWG:</strong> 14AWG
                    </li>
                    <li>
                      <strong>Maximum Power:</strong> 720W <sup>1</sup>
                    </li>
                    <li>
                      <strong>Supported Mode:</strong> Charge only <sup>2</sup>
                    </li>
                  </ul>
                  <hr />
                  <p class="caption" style="font-size:0.9em;">
                    <strong>1.</strong> When using the XT60 output cable, the
                    charging speed may be limited by both the input capacity of
                    the power station and the XT60 cable itself.{" "}
                    <strong>2.</strong> When using this cable, the alternator
                    charger only supports Charge Mode.
                  </p>
                </Fragment>
              ),
            },
          ]}
        />
        <p>
          EcoFlow recommends you keep the total electrical load of the vehicle,
          including all accessories and the alternator charger, below 50% of the
          alternator's rated capacity. EcoFlow states a typical alternator
          generates approximately twice the power required for a basic vehicle
          system while driving.
        </p>

        <SlugHeading tag="h3">Check Compatibility</SlugHeading>
        <p>
          View my{" "}
          <Link href={namedRoutes.ecoflow.altCharger.gen2Compatibility}>
            detailed compatibility guide
          </Link>{" "}
          for confirmed EcoFlow power station support and 3rd-party battery
          system limits. My guide outlines the exact wattage limits for every
          combination of EcoFlow power station, alternator charger model, and
          output cable (XT60, XT150, or 4+8). It also includes a{" "}
          <strong>compatibility calculator</strong> for 3rd-party brands like
          BLUETTI, Jackery, and Anker to ensure your setup is safe and
          efficient.
        </p>
        <ReviewItem href={namedRoutes.ecoflow.altCharger.gen2Compatibility} />

        <p>
          <strong>Unsure which port or cable to use?</strong> My{" "}
          <Link href={namedRoutes.ecoflow.altCharger.gen2CableGuide}>
            cable connection guide
          </Link>{" "}
          includes the exact <strong>port types</strong> and{" "}
          <strong>port counts</strong> for every EcoFlow model, along with all
          cable options, adapters, and maximum charging rates.
        </p>
        <ReviewItem href={namedRoutes.ecoflow.altCharger.gen2CableGuide} />
      </Center>
      <Center>
        <SlugHeading tag="h2">Cables and Accessories</SlugHeading>
        <SlugHeading tag="h3">Output Cables</SlugHeading>
        <p>
          Cable type determines system compatibility, available features, and
          maximum power output. Ideally you would be able to select which cable
          you want included when purchasing, but that's not the case.
        </p>
        <ul class="none">
          <li>
            <PhotoListItem
              affiliateData={affiliateMerchants.ecoflow}
              href={
                data.xt150.link
                  ? data.xt150.link
                  : "https://jp.ecoflow.com/products/ecoflow-alternator-charger-xt150output-new-1m"
              }
              img="/images/products/ecoflow/alternator-charger-plus-1000/xt150-cable.webp"
              title="XT150 output cable"
              titleSuffix={data.xt150.link ? null : "(Japan link)"}
              description={
                <Fragment>
                  Included in: 1000W model (12AWG, 1m)
                  <br />
                  Supports: charging (full rate), reverse charging, battery
                  maintenance
                </Fragment>
              }
              buttonText="EcoFlow"
              buttonIcon="EcoFlow"
            />
          </li>
          <li>
            <PhotoListItem
              affiliateData={affiliateMerchants.ecoflow}
              href={
                data.xt60.link
                  ? data.xt60.link
                  : "https://jp.ecoflow.com/products/ecoflow-alternator-charger-xt60output"
              }
              img="/images/products/ecoflow/alternator-charger-600/xt60-cable.webp"
              title="XT60 output cable"
              titleSuffix={data.xt60.link ? null : "(Japan link)"}
              description={
                <Fragment>
                  Included in: 600W model (14AWG, 1m)
                  <br />
                  Supports: charging (720W maximum)
                </Fragment>
              }
              buttonText="EcoFlow"
              buttonIcon="EcoFlow"
            />
          </li>
          <li>
            <PhotoListItem
              affiliateData={affiliateMerchants.ecoflow}
              href="https://jp.ecoflow.com/products/ecoflow-alternator-charger-4-8output"
              img="/images/products/ecoflow/accessories/output-cable-4+8.webp"
              title="4+8 output cable"
              titleSuffix="(Japan Link)"
              description={
                <Fragment>
                  Sold separately
                  <br />
                  Supports: charging (full rate), reverse charging, battery
                  maintenance
                </Fragment>
              }
              buttonText="EcoFlow"
              buttonIcon="EcoFlow"
            />
          </li>
        </ul>

        <SlugHeading tag="h3">Accessories</SlugHeading>
        <ul class="none">
          <li>
            <PhotoListItem
              affiliateData={affiliateMerchants.ecoflow}
              href={
                data.plus1000Solar.link
                  ? data.plus1000Solar.link
                  : "https://au.ecoflow.com/products/ecoflow-alternator-charger-plus-1000-solar-input-cable"
              }
              img="/images/products/ecoflow/alternator-charger-plus-1000/solar-cable.webp"
              title="Plus 1000 Solar Input Cable"
              titleSuffix={data.plus1000Solar.link ? null : "(Australia link)"}
              description={
                <Fragment>
                  Sold separately (expected soon)
                  <br />
                  16.4ft (5m), 12AWG
                </Fragment>
              }
              buttonText="EcoFlow"
              buttonIcon="EcoFlow"
            />
          </li>
          <li>
            <PhotoListItem
              affiliateData={affiliateMerchants.ecoflow}
              href="https://us.ecoflow.com/products/delta-pro-to-smart-generator-adapter?variant=39704596152393"
              img="/images/products/ecoflow/accessories/smart-generator-adapter.webp"
              title="Smart Generator Adapter"
              description={
                <Fragment>
                  Required by some power stations when using XT150 output cable
                </Fragment>
              }
              buttonText="EcoFlow"
              buttonIcon="EcoFlow"
            />
          </li>
          <li>
            <PhotoListItem
              affiliateData={affiliateMerchants.ecoflow}
              href="https://us.ecoflow.com/products/ecoflow-extra-battery-expansion-adapter?variant=55507615645769"
              img="/images/products/ecoflow/accessories/extra-battery-expansion-adapter.webp"
              title="Extra Battery Expansion Adapter"
              description={
                <Fragment>
                  Connects an alternator charger and extra battery for the DELTA
                  3 Max Plus and Ultra Plus
                </Fragment>
              }
              buttonText="EcoFlow"
              buttonIcon="EcoFlow"
            />
          </li>
          <li>
            <PhotoListItem
              affiliateData={affiliateMerchants.ecoflow}
              href="https://us.ecoflow.com/products/ecoflow-alternator-charger-extended-fuse-cable-2m"
              img="/images/products/ecoflow/accessories/extended-fuse-cable-2m.webp"
              title="Extended Fuse Cable"
              description={<Fragment>Length: 2m</Fragment>}
              buttonText="EcoFlow"
              buttonIcon="EcoFlow"
            />
          </li>
          {/* <li>
            <PhotoListItem
              external
              img=""
              title="Smart Extra Battery Expansion Adapter"
              description={
                <Fragment>
                  (expected by January 2026)
                </Fragment>
              }
              buttonText="EcoFlow"
              buttonIcon="EcoFlow"
            />
          </li> */}
        </ul>
      </Center>
      <Center>
        <SlugHeading tag="h2">Ignition Wire</SlugHeading>

        <Image
          right
          background={true}
          src="/images/products/ecoflow/alternator-charger-plus-1000/input-cable.webp"
        />
        <p>
          The new alternator chargers include an ignition wire that enables it
          to automatically power on when the vehicle starts. This improves
          reliability over Gen 1 models, which depended on voltage triggers that
          often failed in modern vehicles with smart alternators. By connecting
          to an IGN or ACC fuse, the charger activates automatically,
          eliminating manual toggling and voltage triggers.
        </p>

        <p>
          This resolves key issues I noted about{" "}
          <Link
            blank
            href={`${namedRoutes.ecoflow.altCharger.review}#auto-shut-off-issue`}
          >
            auto-shut off
          </Link>{" "}
          and{" "}
          <Link
            blank
            href={`${namedRoutes.ecoflow.altCharger.review}#start-voltage-annoyance`}
          >
            smart alternators
          </Link>{" "}
          for the previous models (500W and 800W).
        </p>

        <Image
          border
          right
          src="/images/products/ecoflow/alternator-charger-plus-1000/ignition-example.webp"
        />

        <p>
          Refer to your vehicle's manual to locate a circuit powered only when
          the ignition is on (IGN is preferred). Some vehicles include a
          dedicated ignition relay. Always verify with a multimeter and follow
          safety procedures.
        </p>

        <SlugHeading tag="h3">Use a Fuse Tap</SlugHeading>
        <Warning prefix="Warning">
          The EcoFlow manuals and install video{" "}
          <strong>wrongly instructs customers</strong> to wrap the ignition wire
          around the fuse terminal. A stray wire can easily bridge both sides of
          the fuse, bypassing its protective function entirely. If that happens,
          the fuse will no longer interrupt current during a fault, increasing
          the risk of damage or fire.
        </Warning>
        <p>
          Purchase a <strong>dedicated fuse tap</strong>. Fuse taps are
          inexpensive, easy to install, and ensure a secure, reliable
          connection. Before ordering, confirm which fuse type your vehicle uses
          (ATO/ATC, mini, micro2, etc.). Compatibility matters so if you're
          unsure, visit a local auto parts store. They can quickly identify the
          correct type and help get what you need.
        </p>
        <PhotoListItem
          affiliate="https://amzn.to/49dBIgi"
          href="https://www.amazon.com/dp/B078T6NLTP/"
          img="/images/products/fuse-tap.webp"
          title="12V-24V Fuse Tap"
          description={<Fragment>Multiple types available</Fragment>}
          shadow
          buttonText="Amazon"
          buttonIcon="Amazon"
          buttonSecondary
        />

        <h4>Ignition Relays</h4>
        <p>
          Some vehicles, especially those designed with upfitter support (like
          vans, trucks, and fleet vehicles) often offer ignition-switched
          terminals or relays that simplify installation and avoids needing to
          use a fuse tap.
        </p>

        <SlugHeading tag="h3">Toggle Switch</SlugHeading>
        <p>
          In addition to routing the ignition wire, a physical{" "}
          <Link
            affiliate="https://amzn.to/4oG9RKH"
            href="https://www.amazon.com/dp/B0C99GSRD3/"
          >
            switch
          </Link>{" "}
          can be installed in a convenient location to manually disable the
          alternator charger. This feature helps reduce alternator wear and
          improve fuel efficiency (especially when paired with a smart
          alternator). When the switch is turned on, the charger remains
          ignition-controlled as usual.
        </p>
        {/* <PhotoListItem
          affiliate="https://amzn.to/43w7Acm"
          href="https://www.amazon.com/dp/B0C99GSRD3/"
          img="/images/products/nilight-green-rocker-switch.webp"
          title="Nilight Rocker Switch"
          titleSuffix="(3 pack)"
          description={<Fragment>Price: $12.15</Fragment>}
          buttonText="Amazon"
          buttonIcon="Amazon"
          buttonSecondary
        /> */}
      </Center>
      <Center>
        <SlugHeading tag="h2">Interesting Configurations</SlugHeading>
        <p>
          These system supports a range of flexible configurations that expand
          charging options and solar capacity.
        </p>
        <ul>
          <li>
            <strong>Single Cable:</strong> Ideal for overlanders and mobile
            users who frequently remove their power station. The Alternator
            Charger Plus 1000 supports both solar and alternator charging
            through a single cable, making it easier to disconnect and
            reinstall.
          </li>
          <li>
            <strong>Four Solar Inputs:</strong> By combining a Delta Pro 3 with
            two 1000W alternator chargers, users can run four solar arrays. This
            expands the system's solar intake to a theoretical maximum of
            3,200W.
          </li>
          <li>
            <strong>Second Solar Array:</strong> Some power stations, like the
            original Delta Pro, have been limited to a single solar array. The
            1000W alternator charger adds a second solar input, unlocking
            dual-array capability.
          </li>
          <li>
            <strong>Power Switch:</strong> Routing the ignition wire to a
            physical switch near the driver's seat allows quick manual control.
            The system can still be ignition-controlled, but the switch provides
            a way to turn it off when not needed, helping reduce wear on the
            alternator. The setup could be as simple as a basic{" "}
            <Link
              affiliate="https://amzn.to/4oG9RKH"
              href="https://www.amazon.com/dp/B0C99GSRD3/"
            >
              rocker switch
            </Link>{" "}
            or as advanced as a{" "}
            <Link external href="https://www.garmin.com/en-US/p/718849/">
              Garmin PowerSwitch
            </Link>{" "}
            (adds control via touchscreen or phone).
          </li>
        </ul>
      </Center>
      <Center>
        <SlugHeading tag="h2">Mobile App</SlugHeading>
        <p>
          The Alternator Charger requires connection to the EcoFlow app to
          enable operation and select working modes. It is available on{" "}
          <Link
            external
            href="https://apps.apple.com/us/app/ecoflow-power-a-new-world/id1506693140"
          >
            iOS
          </Link>{" "}
          and{" "}
          <Link
            external
            href="https://play.google.com/store/apps/details?id=com.ecoflow&hl=en_US"
          >
            Android
          </Link>
          , and supports CarPlay and Android Auto.
        </p>

        <h3>New Setup Steps</h3>
        <p>
          Before using the Alternator Charger for the first time, complete the
          initial setup in the EcoFlow app. The app will guide you through
          selecting your vehicle type, battery voltage, starting voltage,
          portable power station model, and installation methods (orientation).
        </p>
        <ImageSet
          size={6}
          images={[
            {
              lg: "/images/products/ecoflow/alternator-charger-plus-1000/app-setup.webp",
              alt: "",
            },
            {
              lg: "/images/products/ecoflow/alternator-charger-plus-1000/app-orientation.webp",
              alt: "",
            },
          ]}
        />

        <Image
          right
          maxHeight={100}
          src="/images/products/ecoflow/alternator-charger-plus-1000/c6352844-3f71-4c22-bfb0-1baf61e5bd25_2.gif"
        />
        <h3>Switching Modes</h3>
        <p>
          When connecting your EcoFlow portable power station using an XT150 or
          4+8 output cable, you can choose from three operating modes:
        </p>
        <ul>
          <li>Charge Mode</li>
          <li>Reverse Charge Mode</li>
          <li>Battery Maintenance Mode</li>
        </ul>

        <h4>Charge Mode</h4>
        <p>
          This is the default and most commonly used mode. It allows your
          vehicle's alternator to charge the power station while you drive. This
          setup is ideal for medium to long road trips where access to shore
          power is limited. With enough drive time, you can arrive at your
          destination with a fully charged battery.
        </p>

        <h4>Reverse Charge Mode</h4>
        <p>
          If your vehicle battery dies and help isn't available, Reverse Charge
          Mode allows your EcoFlow power station to recharge the starter battery
          directly. This feature only works with the XT150 and 4+8 output cables
          and is not compatible with XT60.
        </p>

        <h4>Maintenance Mode</h4>
        <p>
          This mode delivers a steady 100W trickle charge to maintain your
          vehicle battery's health during long periods of inactivity.
          {/* However,
          the fixed output limits flexibility. An adjustable maintenance rate
          (similar to Reverse Charge Mode) would give users more control and
          customization. */}{" "}
          This feature only works with the XT150 and 4+8 output cables and is
          not compatible with XT60.
        </p>

        <Image
          right
          maxHeight={100}
          src="/images/products/ecoflow/alternator-charger-plus-1000/a531b5c7-f44b-48ea-a4bf-5eb9f67b9cce_2.gif"
        />
        <h3>Start/Stop Charging</h3>
        <p>
          To manually start or stop charging, open the EcoFlow app and use the
          slider control located at the bottom of the device's home screen.
        </p>
        <div style="clear:both;" />
      </Center>

      <Center>
        <SlugHeading tag="h2">Videos</SlugHeading>
        <div class={style.videoSplit}>
          <div>
            <div>Showcase</div>
            <YouTube
              id={data.videos.showcase ? data.videos.showcase : "CfIZJdRv-eg"}
            />
          </div>
          <div>
            <div>Install</div>
            <YouTube
              id={data.videos.install ? data.videos.install : "B8diLDO-r_A"}
            />
          </div>
        </div>
      </Center>
      <Center>
        <SlugHeading tag="h2">Questions &amp; Feedback for EcoFlow</SlugHeading>

        <Accordion
          headingsAs="h3"
          items={[
            {
              heading: "Questions",
              content: (
                <Fragment>
                  <p>
                    Responses to these questions will be incorporated into the
                    page:
                  </p>
                  <ul>
                    <li>
                      <strong>Dual Alternator Chargers:</strong> The product
                      manual states dual 1000W alternator chargers can be used
                      with a Delta Pro 3. Can dual 600W chargers be used? Can a
                      1000W and 600W charger be used simultaneously? If not,
                      while this is an awesome improvement, it also uses up both
                      extra battery ports on the Delta Pro 3.
                    </li>
                    <li>
                      <strong>Smart Extra Battery Expansion Adapter:</strong>{" "}
                      Will the upcoming Smart Extra Battery Expansion Adapter
                      allow users to connect an extra battery and an alternator
                      charger to the same port?
                    </li>
                    <li>
                      <strong>Orientation:</strong> The app and manual shows
                      "upright" and "flat" as valid orientations. Can it be
                      mounted upright on a wall but rotated 90° or 180°? Can it
                      be mounted flat on a ceiling?
                    </li>
                    <li>
                      <strong>Audio Cues:</strong> Can the audio cues' volume be
                      adjusted or disabled in the EcoFlow app?
                    </li>
                  </ul>
                </Fragment>
              ),
            },
            {
              heading: "Feedback",
              content: (
                <Fragment>
                  <p>
                    Hoping this feedback can help improve future revisions and
                    updates:
                  </p>
                  <ul>
                    <li>
                      <strong>Fuse Tap:</strong> The product manuals and install
                      videos should be updated to show the proper use of fuse
                      taps. Wrapping wires around fuse terminals can disable
                      protection and create a serious safety risk.
                    </li>
                    <li>
                      <strong>Output Cable:</strong> Including a default output
                      cable adds cost without always adding value. Many users
                      end up buying a different cable and never use the
                      original. Offering the charger without a bundled cable
                      would lower the base price and let customers choose only
                      what they need. This would also allow many users to not
                      have to purchase the{" "}
                      <Link
                        affiliateData={affiliateMerchants.ecoflow}
                        href="https://us.ecoflow.com/products/delta-pro-to-smart-generator-adapter?variant=39704596152393"
                      >
                        Smart Generator Adapter
                      </Link>{" "}
                      and get the 4+8 output cable instead.
                    </li>
                    <li>
                      <strong>Replacement Fuse:</strong> EcoFlow should sell the
                      125A AEP fuse (
                      <Link
                        external
                        href="https://pim.adlerelectric.com/var/file_storage/catalog/e/2/f/d/e2fda88566fe25e8834fa943def0e520e40720b9_AEP_M5_Bolt_65Vdc_EV_Fuse.pdf"
                      >
                        AEP3125301
                      </Link>
                      ) and publish its specs. Without clear documentation or
                      sourcing, users are left reverse-engineering a critical
                      safety component.
                    </li>
                    <li>
                      <strong>Fuse Size:</strong> The fuse's rated amperage
                      should reflect cable capacity and max current to ensure
                      proper protection. Using the same 125A fuse for both the
                      600W (8 AWG) and 1000W (6 AWG) models seems incorrect.
                    </li>
                    <li>
                      <strong>Solar Cable Length:</strong> The 16.4ft (5m) Plus
                      1000 Solar Input Cable is excessive for many installs,
                      adding cost and clutter. A 1ft option would resolve this
                      and could be used with an extension if needed.
                    </li>
                    <li>
                      <strong>Solar Input Voltage:</strong> The 60V solar input
                      limit restricts panel configurations. Increasing this
                      threshold in future models would give users more
                      flexibility with series connections.
                    </li>
                    <li>
                      <strong>App Requirement:</strong> Both alternator chargers
                      depend entirely on the EcoFlow app to function. Without
                      long-term app support or a listed service agreement, they
                      risk becoming unusable. Offering an optional physical
                      remote would extend product life and give users quick
                      access to key features without relying on a phone with a
                      specific operating system version.
                    </li>
                    <li>
                      <strong>Orientation Detection:</strong> Rather than
                      relying on users to manually select device orientation,
                      consider adding a sensor to detect it automatically. This
                      would reduce setup errors and improve reliability.
                    </li>
                    <li>
                      <strong>
                        LiFePO<sub>4</sub> Battery Support:
                      </strong>{" "}
                      The firmware and app should support proper LFP charging
                      profiles. The current 13.8V output is often insufficient
                      for full charging.
                    </li>
                    <li>
                      <strong>Automatic maintenance mode:</strong> The chargers
                      should include a configurable setting that, once the
                      vehicle is turned off, automatically enables battery
                      maintenance mode after a user-defined period of
                      inactivity. This feature is important in scenarios where
                      the vehicle battery must remain fully charged or RVs that
                      may sit unused for weeks/months. By allowing users to
                      select durations like 10 minutes, 1 hour, 1 day, 3 days,
                      or 7 days, the system can adapt to different needs.
                    </li>
                    {/* <li>
            <mark>Support lithium batteries to be reverse charged.</mark>
          </li> */}
                  </ul>
                </Fragment>
              ),
            },
          ]}
        />
      </Center>
      <Center>
        <SlugHeading tag="h2">Summary</SlugHeading>
        <p>
          <strong>
            EcoFlow continues to push the envelope in alternator charger
            innovation.
          </strong>{" "}
          The new Alternator Charger 600 and Alternator Charger Plus 1000 build
          on their predecessors with meaningful upgrades, introducing higher
          output, smart ignition control, dual-charger support, solar input, and
          tool-free cable design. These upgrades position EcoFlow ahead of the
          curve and strengthen its reputation as a leader in alternator charging
          technology. It's rewarding to see my past feedback, along with that of
          other users, directly reflected in the final product.
        </p>

        {data[1000].link || data[600].link ? (
          <ButtonList>
            {data[1000].link ? (
              <Button
                affiliateData={affiliateMerchants.ecoflow}
                href={data[1000].link}
                icon="EcoFlow"
              >
                Order Plus 1000 Model
              </Button>
            ) : null}
            {data[600].link ? (
              <Button
                affiliateData={affiliateMerchants.ecoflow}
                href={data[600].link}
                secondary
                icon="EcoFlow"
              >
                Order 600 Model
              </Button>
            ) : null}
          </ButtonList>
        ) : null}

        <p>
          Check back here for updates as more information becomes available.
        </p>

        <EcoFlowCouponCode
          href="https://us.ecoflow.com/"
          buttonText="EcoFlow Store"
        />

        <ul>
          <li>
            <strong>Australia:</strong>{" "}
            <Link
              affiliateData={affiliateMerchants.ecoflow}
              href="https://au.ecoflow.com/products/ecoflow-alternator-charger-plus-1000"
            >
              1000W
            </Link>
          </li>
          <li>
            <strong>Europe:</strong>{" "}
            <Link
              affiliateData={affiliateMerchants.ecoflow}
              href="https://eu.ecoflow.com/products/600w-alternator-charger?variant=50705288986967"
            >
              600W
            </Link>{" "}
            and{" "}
            <Link
              affiliateData={affiliateMerchants.ecoflow}
              href="https://eu.ecoflow.com/products/1000w-alternator-charger?variant=48080282714455"
            >
              1000W
            </Link>
          </li>
          <li>
            <strong>France:</strong>{" "}
            <Link
              affiliateData={affiliateMerchants.ecoflow}
              href="https://fr.ecoflow.com/products/600w-alternator-charger?variant=50611851395419"
            >
              600W
            </Link>{" "}
            and{" "}
            <Link
              affiliateData={affiliateMerchants.ecoflow}
              href="https://fr.ecoflow.com/products/chargeur-d-alternateur-ecoflow-1000-w-1?variant=51212363530587"
            >
              1000W
            </Link>
          </li>
          <li>
            <strong>Italy:</strong>{" "}
            <Link
              affiliateData={affiliateMerchants.ecoflow}
              href="https://it.ecoflow.com/products/600w-alternator-charger?variant=55236143055224"
            >
              600W
            </Link>{" "}
            and{" "}
            <Link
              affiliateData={affiliateMerchants.ecoflow}
              href="https://it.ecoflow.com/products/1000w-alternator-charger?variant=50977668006237"
            >
              1000W
            </Link>
          </li>
          <li>
            <strong>Japan:</strong>{" "}
            <Link
              affiliateData={affiliateMerchants.ecoflow}
              href="https://jp.ecoflow.com/products/ecoflow-alternator-charger-600?variant=52234748395887"
            >
              600W
            </Link>{" "}
            and{" "}
            <Link
              affiliateData={affiliateMerchants.ecoflow}
              href="https://jp.ecoflow.com/products/ecoflow-alternator-charger-plus-1000?variant=52234754785647"
            >
              1000W
            </Link>
          </li>
          <li>
            <strong>Spain:</strong>{" "}
            <Link
              affiliateData={affiliateMerchants.ecoflow}
              href="https://es.ecoflow.com/products/600w-alternator-charger"
            >
              600W
            </Link>{" "}
            and{" "}
            <Link
              affiliateData={affiliateMerchants.ecoflow}
              href="https://es.ecoflow.com/products/1000w-alternator-charger?variant=48146695094619"
            >
              1000W
            </Link>
          </li>
          <li>
            <strong>United Kingdom:</strong>{" "}
            <Link
              affiliateData={affiliateMerchants.ecoflow}
              href="https://uk.ecoflow.com/products/600w-alternator-charger?variant=51029173207379"
            >
              600W
            </Link>{" "}
            and{" "}
            <Link
              affiliateData={affiliateMerchants.ecoflow}
              href="https://uk.ecoflow.com/products/1000w-alternator-charger?variant=48154485850451"
            >
              1000W
            </Link>
          </li>
        </ul>

        <Tags tags={headerInfo.tags} brands={headerInfo.brands} />
      </Center>
      <Center>
        <h3>Related</h3>
        <ul class="none">
          <li>
            <ReviewItem href={namedRoutes.ecoflow.altCharger.gen2CableGuide} />
          </li>
          <li>
            <ReviewItem href={namedRoutes.ecoflow.altCharger.review} />
          </li>
          <li>
            <ReviewItem href={namedRoutes.alternatorChargers} />
          </li>
          <li>
            <ReviewItem href={namedRoutes.ecoflow.altCharger.transit} />
          </li>
          <li>
            <ReviewItem href={namedRoutes.ecoflow.wiring12v} />
          </li>
          <li>
            <ReviewItem href={namedRoutes.ecoflow.vanlife} />
          </li>
        </ul>
      </Center>
      <Questions />
      <Center>
        <Author
          author
          published={headerInfo.datePublished}
          updated={headerInfo.dateModified}
        />
      </Center>
    </Editorial>
  </div>
);

export default Page;
